/**
 * Script for Front Page
 *
 * @author Space-Time Inc.
 * @version 2022-10-03
 */

/**
 * Splash Screen - Front Page
 *
 * @author Space-Time Inc.
 * @version 2022-10-03
 */

document.addEventListener('DOMContentLoaded', () => {
	const KEY   = 'splash';
	const LIMIT = (1000 * 60 * 30);  // 30 min.

	initSplash();

	function initSplash() {
		if (!location.hash && LIMIT < getElapsedTime()) {
			window.scrollTo(0, 0);
			setTimeout(() => {
				document.body.classList.add('splash');
			}, 1000);
			setTimeout(() => {
				document.body.classList.remove('splash', 'loading');
			}, 3000);
		} else {
			document.body.classList.add('no-splash');
			document.body.classList.remove('loading');
		}
		setCurrentTime();
	}

	function getElapsedTime() {
		const time = localStorage.getItem(KEY);
		return time ? Date.now() - time : Number.MAX_VALUE;
	}

	function setCurrentTime() {
		localStorage.setItem(KEY, Date.now());
	}

});

/**
 * Top Visual - Front Page
 *
 * @author Space-Time Inc.
 * @version 2022-10-28
 */

document.addEventListener('DOMContentLoaded', () => {
	initToLatest();
	initTopVisual();

	function initToLatest() {
		const btn = document.querySelector('.to-latest');
		if (!btn) return;

		btn.addEventListener('click', () => {
			const tar = document.querySelector('.entry-header h2');
			if (tar) tar.scrollIntoView({ behavior: 'smooth' });
		});
	}


	// -------------------------------------------------------------------------


	function initTopVisual() {
		const sky1 = document.querySelector('.sky');
		const sky2 = document.querySelector('.sky-alt');
		if (!sky1 || !sky2) return;

		const bns1 = Array.from(document.querySelectorAll('.sky .balloon'));
		const bns2 = Array.from(document.querySelectorAll('.sky-alt .balloon'));
		if (!bns1.length || !bns2.length) return;

		const fppCat  = document.querySelector('.modal-panel.category');
		const fppMenu = document.querySelector('.modal-panel.menu');
		const menuBtn = document.querySelector('.site-header .menu-button');

		let curPanel = null;

		const iDs = new Set(['menu']);
		for (const bn of bns2) {
			iDs.add(bn.dataset.slug);
		}
		const mh = new ModalHistory(iDs, '', doOpen, doClose);

		initBalloon1(sky1, bns1);
		initBalloon2(sky2, bns2);

		initPanel(fppCat, mh);
		initPanel(fppMenu, mh);

		for (const bn of [...bns1, ...bns2]) {
			bn.addEventListener('click', () => {
				if (curPanel) {
					mh.move(bn.dataset.slug);
				} else {
					mh.start(bn.dataset.slug);
				}
			});
		}

		menuBtn.addEventListener('click', () => {
			mh.start('menu');
		});

		function doOpen(id, oldId) {
			document.body.classList.add('modal');

			if ('menu' === id) {
				fppMenu.classList.add('open');
				curPanel = fppMenu;
			} else {
				let bn = null;
				for (const b of bns2) {
					if (id === b.dataset.slug) {
						bn = b;
					}
				}
				prepareCategoryPanel(fppCat, bn, [...bns1, ...bns2]);
				if (!oldId) fppCat.classList.add('open');
				curPanel = fppCat;
			}
			menuBtn.classList.add('open');
		}

		function doClose() {
			curPanel.classList.remove('open');
			document.body.classList.remove('modal');
			curPanel = null;
			menuBtn.classList.remove('open');
		}
	}

	function initPanel(panel, mh) {
		const btnClose = panel.querySelector('button');
		btnClose.addEventListener('click', () => {
			mh.end();
		});
	}

	function prepareCategoryPanel(fpp, curBn, bns) {
		const cat = curBn.dataset.slug;

		for (const bn of bns) {
			bn.classList.remove('active');
			if (bn.dataset['slug'] === cat) bn.classList.add('active');
		}

		const title     = fpp.querySelector('h2');
		title.innerHTML = curBn.innerHTML;

		const items = Array.from(fpp.querySelectorAll('.list-item-article > li'));
		const cls   = 'article_category-' + cat;

		for (const it of items) {
			it.style.display = it.classList.contains(cls) ? null : 'none';
		}
	}

	function initBalloon1(sky, bns) {
		for (const bn of bns) {
			bn.style.animationDelay = `-${Math.random()}s`;
		}
		function rh() {
			const { width: cx, height: cy } = sky.getBoundingClientRect();
			const base = 0.2 * Math.sqrt(cx * cx + cy * cy) + 0.8 * Math.min(cx, cy);
			const size = Math.max(88, Math.min(200, base / 5));
			sky.style.setProperty('--balloon-size', size + 'px');
		}
		window.addEventListener('resize', throttle(rh), { passive: true });
		rh();
	}

	function initBalloon2(sky, bns) {
		function rh() {
			const { width: cx, height: cy } = sky.getBoundingClientRect();
			const num  = bns.length;
			const size = Math.min(cy, Math.max(cy / 2 - 16, (cx - 16 * (num - 1)) / num));
			sky.style.setProperty('--balloon-size', `${size}px`);
		}
		window.addEventListener('resize', throttle(rh), { passive: true });
		rh();
	}


	// -------------------------------------------------------------------------


	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	

});

/**
 * Latest Article - Front Page
 *
 * @author Space-Time Inc.
 * @version 2022-12-26
 */

document.addEventListener('DOMContentLoaded', () => {
	initList();

	function initList() {
		const btn   = document.querySelector('#see-all');
		const list  = document.querySelector('.list-item-article.latest');
		const items = document.querySelectorAll('.list-item-article.latest > li');
		if (!btn || !list || !items.length) return;

		let doAlignItems = true;

		btn.addEventListener('click', () => {
			btn.parentElement.style.display = 'none';
			list.style.maxHeight            = '9999vh';
			list.style.transitionDuration   = '4s';

			doAlignItems = false;
		});

		function rh() {
			if (!doAlignItems) return;
			const lb = list.getBoundingClientRect();

			const cc  = calcColumCount(items);
			const max = cc === 1 ? 4 : (cc === 2 ? 4 : (cc === 3 ? 6 : 6));

			if (items.length <= max) {
				btn.parentElement.style.display = 'none';
				list.style.maxHeight            = 'unset';
			} else {
				btn.parentElement.style.display = null;
				for (let i = 0; i < items.length; i += 1) {
					if (i === max - 1) {
						const ib = items[i].getBoundingClientRect();
						list.style.maxHeight = `${ib.bottom - lb.top}px`;
						break;
					}
				}
			}
		}
		window.addEventListener('resize', throttle(rh), { passive: true });
		rh();

		function calcColumCount(items) {
			const ib  = items[0].getBoundingClientRect();
			const top = ib.top;
			let cc = 1;

			for (let i = 1; i < items.length; i += 1) {
				const it = items[i];
				const ib = it.getBoundingClientRect();
				if (top === ib.top) {
					cc += 1;
				} else {
					break;
				}
			}
			return cc;
		}
	}


	// -------------------------------------------------------------------------


	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	

});

